import { 
  auth,
  signInWithEmailAndPassword,
  signOut,
  googleAuthProvider, 
  facebookAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword
} from 'auth/FirebaseAuth';
import { messaging } from 'configs/FirebaseConfig';
import { getToken } from 'firebase/messaging';

const VAPID_KEY = 'BAhX4NfPZ39WmUqo9FLN_sc7kuS-T0BJfzvEnEaibYoeu3o7R8AtFNAWssv1XA_ffH9pCkKvJPsHUzZIVEfMPI8';

const FirebaseService = {}

FirebaseService.signInEmailRequest = async (email, password) => {
  return await signInWithEmailAndPassword(auth, email, password).then(user => user).catch(err => err);
}

FirebaseService.signOutRequest = async () =>
	await signOut(auth).then(user => user).catch(err => err);

FirebaseService.signInGoogleRequest = async () =>
  await signInWithPopup(auth, googleAuthProvider).then(user => user).catch(err => err);

FirebaseService.signInFacebookRequest = async () =>
  await signInWithPopup(auth, facebookAuthProvider).then(user => user).catch(err => err);

FirebaseService.signUpEmailRequest = async (email, password) =>
	await createUserWithEmailAndPassword(auth, email, password).then(user => user).catch(err => err);	

FirebaseService.requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  } catch (error) {
    console.warn('Notification permission request failed:', error);
    return false;
  }
};

FirebaseService.getFcmToken = async () => {
  try {
    const token = await getToken(messaging, { vapidKey: "BAhX4NfPZ39WmUqo9FLN_sc7kuS-T0BJfzvEnEaibYoeu3o7R8AtFNAWssv1XA_ffH9pCkKvJPsHUzZIVEfMPI8" });
    return token;
  } catch (err) {
    console.warn('FCM token error:', err);
    return null;
  }
};
	
export default FirebaseService